import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TooltipComponent = ({ id, title, icon }) => {
  if (!id || !title) return null;

  const Overlay = (
    <Tooltip id={id} placement="top">
      {title}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={Overlay}>
      <i className="ml-1">
        <FontAwesomeIcon icon={icon} id={id} />
      </i>
    </OverlayTrigger>
  );
};

TooltipComponent.defaultProps = {
  icon: ['fas', 'circle-info'],
};

export default TooltipComponent;
